/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface DividendFrequencyRecord {
  id: string;
  name: string;
  description: string;
}

const STALE_TIME = 10 * 60 * 1000; // 10 minutes

export function useDividendFrequencies() {
  return useQuery({
    queryKey: ['dividend_frequencies'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('dividend_frequencies' as any)
        .select('id, name, description')
        .order('name', { ascending: true });
      if (error) throw error;
      return data as DividendFrequencyRecord[];
    },
    staleTime: STALE_TIME,
  });
}
